import { cn } from "../../helpers"
import { body, paragraph } from "../typography"

const container = cn(
  "flex items-center px-4 py-3 sm:py-4 ring-1 ring-neutral-200 rounded-2xl bg-white transition-all",
  "hover:bg-neutral-50 hover:ring-2 hover:ring-neutral-300 hover:cursor-pointer",
  "active:bg-neutral-50 active:ring-2 active:ring-neutral-300"
)
const textContainer = cn("flex flex-1 flex-col gap-1 mx-3 sm:ml-4")
const label = cn(body({ size: "sm" }))
const description = cn(paragraph({ size: "sm", className: "text-neutral-700" }))
const rightElementContainer = cn("flex gap-2")

export { container, textContainer, label, description, rightElementContainer }
